export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/vc74d039ed1881ba30f2ccdf585524fea3ee1697b-runtime-main.656f66ca.worker.js");
}
